// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  MetadataCategory,
} from "./types";


export default __t.row({
  metadataId: __t.u64().primaryKey().name("metadata_id"),
  versionId: __t.u64().name("version_id"),
  fileId: __t.u64().name("file_id"),
  key: __t.string(),
  value: __t.string(),
  get category() {
    return MetadataCategory;
  },
});
